// Identificador de login `username.dominio` — docs/03 §1 y docs/04 §2.
// Usernames y slugs no admiten puntos ⇒ todo identificador tiene a lo sumo un punto
// y el parsing es determinista.

export const USERNAME_REGEX = /^[a-z0-9_-]{3,32}$/

export const DOMAIN_SLUG_REGEX = /^[a-z0-9-]{2,32}$/

// Dominio implícito para identificadores sin sufijo.
export const DEFAULT_DOMAIN = "default"

// Dominio reservado de los admins de instancia (bootstrap).
export const SYSTEM_DOMAIN = "system"

export interface ParsedIdentifier {
  username: string
  domain: string
}

// Normaliza (trim + lowercase) y parsea el identificador. Devuelve `null` si es inválido
// (más de un punto, username o slug fuera de formato): se eligió `null` en lugar de lanzar
// para no acoplar @rema/shared a las clases de error de core — la capa que llama decide
// cómo convertirlo en su error 422/401.
export const parseIdentifier = (raw: string): ParsedIdentifier | null => {
  const normalized = raw.trim().toLowerCase()
  const dotIndex = normalized.indexOf(".")
  if (dotIndex === -1) {
    if (!USERNAME_REGEX.test(normalized)) return null
    return { username: normalized, domain: DEFAULT_DOMAIN }
  }
  // A lo sumo un punto por identificador
  if (normalized.indexOf(".", dotIndex + 1) !== -1) return null
  const username = normalized.slice(0, dotIndex)
  const domain = normalized.slice(dotIndex + 1)
  if (!USERNAME_REGEX.test(username) || !DOMAIN_SLUG_REGEX.test(domain)) return null
  return { username, domain }
}

// Forma canónica para mostrar/devolver: los usuarios del dominio default van sin sufijo.
export const formatIdentifier = (username: string, domain: string): string =>
  domain === DEFAULT_DOMAIN ? username : `${username}.${domain}`
